import { useState, useEffect, useContext, useMemo } from 'react'
import { useLocation, useParams, useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import { getPass } from '/providers/passes-api'
import { getSmartixScannerPassHistory } from '/providers/studio-api'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/pass-scans'
import Menu from '/components/passes/pass-nav-menu'
import ScanTableEvent from '../components/passes/scan-table-event'
import ScanTableStamp from '../components/passes/scan-table-stamp'
import ScanTableGiftcard from '../components/passes/scan-table-giftcard'
import ScanTableLoyalty from '../components/passes/scan-table-loyalty'
import ScanTableMembership from '../components/passes/scan-table-membership'

const PassScans = () => {

  const navigate = useNavigate()

  const { templateId, passId } = useParams()
  const { apiSource, apiKey, templates } = useContext(AppContext)

  const template = useMemo(() => { return templates.filter(t => t.id === templateId)[0] }, [templates, templateId])

  const location = useLocation()

  const [pass, setPass] = useState(location.state?.pass)
  const [scans, setScans] = useState([])
  const [loading, setLoading] = useState(true)

  const getScans = async () => {
    setLoading(true)
    // TODO handle error
    let scans = await getSmartixScannerPassHistory({ apiSource, apiKey, passType: template.pass_type_id, templateId: pass.template_id, passId: pass.pass_id })
    setScans(scans)
    setLoading(false)
  }

  useEffect(() => {
    if (template) getScans()
  }, [pass, template])  

  useEffect(() => {
    if (!location.state) getPassData()
  }, [templateId, passId])

  const getPassData = async () => {
    const p = await getPass({ apiSource, apiKey, templateId, passId })
    if (p.ok === false) navigate("/templates")
    setPass(p.pass)
  }

  if (template && pass) {

    if (template.pass_type_id.replace("_bg","") === "smartix_event") return (
      <PageWrapper title="Entry/exit scans" HelpText={HelpText} heading={`${pass.pass_id} ${pass.mode === "test" ? " [test]" : ""}`} menu={<Menu pass={pass} template={template} />}>
        <ScanTableEvent scans={scans} loading={loading} templateId={templateId} passId={pass.pass_id} />
      </PageWrapper>
    )

    if (template.pass_type_id === "smartix_gift") return (
      <PageWrapper title="Giftcard transactions" HelpText={HelpText} heading={`${pass.pass_id} ${pass.mode === "test" ? " [test]" : ""}`} menu={<Menu pass={pass} template={template} />}>
        <ScanTableGiftcard scans={scans} loading={loading} templateId={templateId} passId={pass.pass_id} />
      </PageWrapper>
    )

    if (template.pass_type_id === "smartix_stamp") return (
      <PageWrapper title="Stamps and redemptions" HelpText={HelpText} heading={`${pass.pass_id} ${pass.mode === "test" ? " [test]" : ""}`} menu={<Menu pass={pass} template={template} />}>
        <ScanTableStamp scans={scans} loading={loading} templateId={templateId} passId={pass.pass_id} />
      </PageWrapper>
    )

    if (template.pass_type_id === "smartix_loyalty") return (
      <PageWrapper title="Loyalty point transactions" HelpText={HelpText} heading={`${pass.pass_id} ${pass.mode === "test" ? " [test]" : ""}`} menu={<Menu pass={pass} template={template} />}>
        <ScanTableLoyalty scans={scans} loading={loading} templateId={templateId} passId={pass.pass_id} />
      </PageWrapper>
    )

    if (template.pass_type_id === "smartix_membership") return (
      <PageWrapper title="Membership scans" HelpText={HelpText} heading={`${pass.pass_id} ${pass.mode === "test" ? " [test]" : ""}`} menu={<Menu pass={pass} template={template} />}>
        <ScanTableMembership scans={scans} loading={loading} templateId={templateId} passId={pass.pass_id} />
      </PageWrapper>
    )

  }
}

export default PassScans